import { END_POINT } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatStatus } from "@utils/string.utils";
import { formatDate } from "@utils/date.util";

const keyColumn = PRIMARY_KEY;
const { USER_STATUS_TOGGLE } = END_POINT;

const tableTitle = "Inventory Items List";
const menuUrl = "inventory/items";
const tableColumn = [
  {
    id: "image",
    numeric: false,
    disablePadding: false,
    label: "Image",
    formatData: (image) => (
      <img
        src={image}
        alt="Image"
        style={{ width: "50px", height: "50px", objectFit: "cover" }}
      />
    ),
  },
  {
    id: "part_number",
    numeric: false,
    disablePadding: false,
    label: "Part No",
  },
  {
    id: "make",
    numeric: false,
    disablePadding: false,
    label: "Make",
  },
  {
    id: "date_code",
    numeric: false,
    disablePadding: false,
    label: "Date Code",
  },
  {
    id: "source",
    numeric: false,
    disablePadding: false,
    label: "Source",
  },
  {
    id: "available_qty",
    numeric: false,
    disablePadding: false,
    label: "Available Quantity",
  },
  {
    id: "price",
    numeric: false,
    disablePadding: false,
    label: "Price",
    formatData: (price) => {
      if (!price) return null;

      const slabs = price.split(",");

      const formatAmount = (amount) => {
        if (!amount) return "";
        const match = amount.match(/₹\s*(\d+\.?\d*)/);
        if (!match) return amount;
        return `₹ ${parseFloat(match[1]).toFixed(2)}`;
      };

      return (
        <div className="text-end">
          {slabs.map((slab, index) => {
            const [range, amount] = slab.split(" - ");
            const formattedAmount = amount ? formatAmount(amount) : "";

            return (
              <p key={index} className="m-0">
                {range?.trim()} - {formattedAmount}
              </p>
            );
          })}
        </div>
      );
    },
    width: "120px",
  },
  {
    id: "lead_time",
    numeric: false,
    disablePadding: false,
    label: "Lead Time",
  },
  {
    id: "mpq",
    numeric: false,
    disablePadding: false,
    label: " MPQ",
    // width: 100,
  },
  {
    id: "alias",
    numeric: false,
    disablePadding: false,
    label: "Alias",
    formatData: (price) => (
      <div>
        {price.split(",").map((p, index) => (
          <p key={index} className="m-0">
            {p.trim()}
          </p>
        ))}
      </div>
    ),
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    badgeClick: USER_STATUS_TOGGLE,
    primaryKey: keyColumn,
    formatData: formatStatus,
    badgeText: {
      1: "Enable",
      2: "Disable",
    },
    badgeColor: {
      1: "success",
      2: "danger",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDate,
    sort: true,
  },
];
const breadCrumbs = [{ name: "Inventory Items", menu_url: "/inventory/items" }];

const filters = ({ manufacturers }) => [
  {
    name: "part_number",
    id: "part_number",
    label: "Part Number",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "make",
    id: "make",
    label: "Make",
    value: "",
    type: "SELECT",
    options: manufacturers,
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
  //   additionalActions,
};
